<script lang="ts">
  import type { AnyCell } from "@okcontract/cells";
  import { isToken, is_org } from "@okcontract/coredata";
  import type { OKPage } from "@okcontract/sdk";
  import { getTheme } from "@okcontract/uic";
  import { ObjectFieldViewString } from "@scv/dataeditor";
  import { OrgSnippet, TokenSnippet } from "@scv/dcuic";

  import Titles from "./Titles.svelte";

  export let instance: OKPage;
  const core = instance.core;

  export let item: any;
  export let size: "smb" | "sm" | "md" = "sm";
  export let chain: AnyCell<string>;

  const theme = getTheme();
  const compiledTheme = theme?.compiled;
</script>

{#if Array.isArray(item)}
  {#each item as element, i}
    <Titles {instance} item={element} size={i % 2 ? "smb" : size} {chain} />
  {/each}
{:else if typeof item === "object"}
  <ul>
    {#each Object.keys(item) as element, i}
      <li>
        {element}
        <Titles {instance} item={item[element]} {chain} />
      </li>
    {/each}
  </ul>
{:else if isToken(item)}
  <!-- should only hover details, not open link  // bg-gray-200 rounded-full -->
  <div
    class="btn btn-sm {theme.dark(
      $compiledTheme,
      'btn-white-alpha',
      'btn-black-alpha',
      'btn-ghost'
    )}"
  >
    <!--style={theme.apply($compiledTheme, [ThemeText])}-->
    <TokenSnippet q={item} small={false} balance={false} />
  </div>
{:else if is_org(item)}
  <div
    class="btn btn-sm {theme.dark(
      $compiledTheme,
      'btn-white-alpha',
      'btn-black-alpha',
      'btn-ghost'
    )}"
  >
    <!--style={theme.apply($compiledTheme, [ThemeText])}-->
    <OrgSnippet q={item} small={false} />
  </div>
{:else if item}
  <div class="gap-1">
    <ObjectFieldViewString
      {instance}
      value={item}
      {size}
      chain={$chain instanceof Error ? null : $chain}
      snippetType={false}
    />
  </div>
{/if}
